import Component from 'vue-class-component';
import OrderListAbstract from '../OrderAbstract/OrderListAbstract';
import OrderTableElement from '../OrderTableElement/OrderTableElement';

@Component({
    components: {
        OrderTableElement
    }
})
export default class OrderTable extends OrderListAbstract {
    header = [
        {
            text: '№ Заказа',
            sortable: false,
            width: 140
        },
        {
            text: 'Дата заказа',
            sortable: false,
            align: 'center',
            width: 195
        },
        {
            text: 'Статус',
            sortable: false,
            align: 'center',
        },
        {
            text: 'Стоимость',
            sortable: false,
            align: 'center',
        },
        {
            text: '',
            sortable: false,
        },
    ]
    mounted() {
        if (this.needFIO) this.header.splice(1, 0, {
            text: 'Наименование клиента',
            sortable: false,
        })
    }
}